import classNames from "classnames";
import React from "react";

import { Icon } from "../../atoms/icon";
import CalendarGrid from "./Grid";
import { Props as GridProps } from "./Grid";
import styles from "./index.module.scss";
import { useDevice } from "../../../contexts/deviceContext";

interface OwnProps extends GridProps {
  clearHandler: React.MouseEventHandler<React.ReactNode>;
  close: () => void;
  nextHandler: React.MouseEventHandler<React.ReactNode>;
  previousHandler: React.MouseEventHandler<React.ReactNode>;
  todayHandler: React.MouseEventHandler<React.ReactNode>;
}

type Props = OwnProps;

export const Calendar: React.NamedExoticComponent<Props> = React.memo(
  ({
    close,
    previousHandler,
    nextHandler,
    clearHandler,
    todayHandler,
    noClear,
    ...gridProps
  }) => {
    const { gridStart, selectionStart, selectionEnd } = gridProps;
    const hasSelected = !!selectionStart || !!selectionEnd;

    const device = useDevice();
    const isMobile = device === "mobile";

    return (
      <div className={styles.root}>
        <div className={styles.top}>
          <div className={styles.elementLeft} />
          <div className={styles.elementCenter}>
            {isMobile ? (
              <div
                onClick={
                  previousHandler as React.MouseEventHandler<HTMLDivElement>
                }
              >
                <Icon
                  className={classNames(styles.icon, styles.clickable)}
                  name="chevron_round_up"
                />
              </div>
            ) : null}
          </div>
          <div className={styles.elementRight} onClick={close}>
            <Icon
              className={classNames(styles.icon, styles.clickable)}
              name="close"
            />
          </div>
        </div>
        <div className={styles.body}>
          {isMobile ? null : (
            <div
              className={classNames(styles.arrowButton, styles.previous)}
              onClick={
                previousHandler as React.MouseEventHandler<HTMLDivElement>
              }
            >
              <Icon
                className={classNames(styles.icon, styles.clickable)}
                name="chevron_round_left"
              />
            </div>
          )}
          <div className={styles.calendars}>
            <CalendarGrid {...gridProps} gridStart={gridStart.clone()} />
            {isMobile ? null : (
              <>
                <div className={styles.separator} />
                <CalendarGrid
                  {...gridProps}
                  gridStart={gridStart.clone().add(1, "month")}
                />
              </>
            )}
          </div>
          {isMobile ? null : (
            <div
              className={classNames(styles.arrowButton, styles.next)}
              onClick={nextHandler as React.MouseEventHandler<HTMLDivElement>}
            >
              <Icon
                className={classNames(styles.icon, styles.clickable)}
                name="chevron_round_right"
              />
            </div>
          )}
        </div>
        <div className={styles.bottom}>
          <div className={styles.elementLeft}>
            {noClear ? null : (
              <div
                className={classNames(styles.footerButton, {
                  [styles.active]: hasSelected,
                })}
                onClick={
                  clearHandler as React.MouseEventHandler<HTMLDivElement>
                }
              >
                クリア
              </div>
            )}
          </div>
          <div className={styles.elementCenter}>
            {isMobile ? (
              <div
                onClick={nextHandler as React.MouseEventHandler<HTMLDivElement>}
              >
                <Icon
                  className={classNames(styles.icon, styles.clickable)}
                  name="chevron_round_down"
                />
              </div>
            ) : null}
          </div>
          <div
            className={classNames(
              styles.footerButton,
              styles.active,
              styles.elementRight,
            )}
            onClick={todayHandler as React.MouseEventHandler<HTMLDivElement>}
          >
            今月に戻る
          </div>
        </div>
      </div>
    );
  },
);

export { default as CalendarController } from "./Controller";
export { default as CalendarInput } from "./Input";
export { default as CalendarGrid } from "./Grid";
